import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useSignInContext } from './SignInContext';
import { Input } from '../../components/form';
import { masterKeyValidator } from '../../components/form/Input/validators/recover-totp-master-key.validator';
import { Button } from '../../components/UI';
import { FormikProvider, useFormik } from 'formik';
import { useMutation } from '@apollo/client';
import { REQUEST_TOTP_BYPASS } from '../../http/apollo-queries';
import { pascalCase } from '../../helpers/functions';
import { Link } from 'react-router-dom';
import { Modal } from '../../components/Modal';
import { logger } from '../../helpers/logger';

const SignInRequest2FABypass = () => {
  const { t } = useTranslation();

  const [requestTOTPBypass, { loading: requestTOTPBypassLoading }] =
    useMutation(REQUEST_TOTP_BYPASS);

  const [error, setError] = useState('');

  const { state, dispatch } = useSignInContext();
  logger.log(state);

  const formik = useFormik({
    initialValues: {
      email: state.email,
      masterKey: '',
      code: '',
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: true,
    onSubmit: (values) => {
      requestTOTPBypass({
        variables: {
          email: formik.values.email,
          masterKey: formik.values.masterKey,
        },
      })
        .then(({ data: { requestTOTPBypass } }) => {
          dispatch({
            type: 'SET_2FA_TOKEN',
            payload: requestTOTPBypass.bypassToken,
          });

          dispatch({
            type: 'SET_STEP',
            payload: 'BYPASS_2FA',
          });

          formik.setSubmitting(false);
        })
        .catch((error) => {
          setError(pascalCase(error.message));
        });
    },
  });

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'base'}
    >
      <div className={'px-32'}>
        <h1 className={'text-black text-xl font-semibold mb-4 dark:text-white'}>
          {t('request2faBypass.title')}
        </h1>
        <p className={'text-grey-50 text-sm whitespace-pre-wrap'}>
          {t('request2faBypass.subtitle')}
        </p>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <div className="mt-12">
              <Input
                formik={formik}
                name="email"
                isDisabled={true}
                id="email"
                type="text"
                size="full"
                label={t('request2faBypass.form.label.email')}
              />
            </div>
            <div className="mt-10">
              <Input
                formik={formik}
                name="masterKey"
                id="masterKey"
                validate={masterKeyValidator}
                type="textarea"
                className={'h-32'}
                size="full"
                label={t('request2faBypass.form.label.masterKey')}
                errorMessage={error}
              />
            </div>
            <div className="mt-10">
              <Button
                type="submit"
                variant="primary"
                buttonClass="w-full"
                loading={formik.isSubmitting}
              >
                {t('request2faBypass.form.label.submit')}
              </Button>
            </div>
            <div className="mt-4 text-center">
              <Trans i18nKey="request2faBypass.problem">
                don't receive
                <Link className={'font-semibold'} to={'/support'}>
                  contact
                </Link>
              </Trans>
            </div>
          </form>
        </FormikProvider>
      </div>
    </Modal>
  );
};

export default SignInRequest2FABypass;
